import Chance from 'chance';
const chance = new Chance();
export const getFakeNumber = (fieldType, state) => {
    let val;
    switch (fieldType) {
        case `auto_increment`:
            val = state.autoIncrement++;
            break;
        default:
            val = chance.floating({
                min: 1,
                max: 10000,
                fixed: 2
            });
            break;
    }
    return val;
};
